export default "__VITE_ASSET__wiePnUjv__"